import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Globe2Icon } from "lucide-react";
import { GB, FR, TN } from "country-flag-icons/react/3x2";
import useLocale from "@/lib/useLocale";

export default function LanguageSwitcher() {
  const { changeLocale } = useLocale();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="flex flex-row items-center px-0 overflow-hidden cursor-pointer">
          <Globe2Icon className="w-4 h-4" strokeWidth="1.5" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => changeLocale("en")}>
          <span className="w-4 h-4 mr-2">🌍</span>
          English
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => changeLocale("fr")}>
          <span className="w-4 h-4 mr-2">🥐</span>
          French
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => changeLocale("ar")}>
          <span className="w-4 h-4 mr-2">🌙</span>
          Arabic
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => changeLocale("zb")}>
          <span className="w-4 h-4 mr-2">🌶️</span> Tunisian
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
